import React, { useEffect } from 'react'
import {BrowserRouter as Router, Routes, Route} from  'react-router-dom'
import NotFound from './components/NotFound'
import IDCardGenerator from './components/id/eventIds'
import Home from './Home'
import DownloadSection from './components/id/Download'
import Speakers from './components/Speakers'
import Header from './components/Header';
import Footer from './components/Footer';
import './css/style.css';
import AIScheduleDisplay from './components/id/AIScheduleDisplay'
import Schedule from './components/id/Schedule'
import AISchedule from './components/id/AISchedule'

function MainRoutes() {
    useEffect(() => {
        // Neural Network Animation
        const createNeuralNetwork = () => {
        const container = document.getElementById('neuralNetwork');
        if (!container) return;
        
        container.innerHTML = '';
        const nodeCount = 20;
        const nodes = [];
        const connections = [];

        // Create nodes
        for (let i = 0; i < nodeCount; i++) {
            const node = document.createElement('div');
            node.className = 'neural-node';
            node.style.left = Math.random() * 100 + '%';
            node.style.top = Math.random() * 100 + '%';
            node.style.animationDelay = Math.random() * 2 + 's';
            container.appendChild(node);
            nodes.push(node);
        }

        // Create connections
        for (let i = 0; i < nodeCount / 2; i++) {
            const connection = document.createElement('div');
            connection.className = 'neural-connection';
            
            const node1 = nodes[Math.floor(Math.random() * nodes.length)];
            const node2 = nodes[Math.floor(Math.random() * nodes.length)];
            
            if (node1 !== node2) {
            const rect1 = node1.getBoundingClientRect();
            const rect2 = node2.getBoundingClientRect();
            
            const angle = Math.atan2(rect2.top - rect1.top, rect2.left - rect1.left);
            const distance = Math.sqrt(Math.pow(rect2.left - rect1.left, 2) + Math.pow(rect2.top - rect1.top, 2));
            
            connection.style.width = distance + 'px';
            connection.style.left = parseFloat(node1.style.left) + '%';
            connection.style.top = parseFloat(node1.style.top) + '%';
            connection.style.transform = `rotate(${angle}rad)`;
            connection.style.animationDelay = Math.random() * 3 + 's';
            
            container.appendChild(connection);
            connections.push(connection);
            }
        }
        };

    // Smooth scrolling for navigation
    const handleSmoothScroll = (e) => {
      if (e.target.tagName === 'A' && e.target.getAttribute('href')?.startsWith('#')) {
        e.preventDefault();
        const target = document.querySelector(e.target.getAttribute('href'));
        if (target) {
          const offsetTop = target.offsetTop - 80;
          window.scrollTo({
            top: offsetTop,
            behavior: 'smooth'
          });
        }
      }
    };

    // Fade in animation on scroll
    const animateOnScroll = () => {
      const elements = document.querySelectorAll('.fade-in');
      elements.forEach(element => {
        const elementTop = element.getBoundingClientRect().top;
        const elementVisible = 150;
        
        if (elementTop < window.innerHeight - elementVisible) {
          element.classList.add('animate');
        }
      });
    };

    // Navbar scroll effect
    const updateNavbar = () => {
      const navbar = document.querySelector('.navbar');
      if (!navbar) return;
      
      if (window.scrollY > 50) {
        navbar.style.background = 'rgba(5, 5, 5, 0.98)';
        navbar.style.backdropFilter = 'blur(20px)';
      } else {
        navbar.style.background = 'rgba(10, 10, 10, 0.95)';
        navbar.style.backdropFilter = 'blur(20px)';
      }
    };

    // Parallax effect for hero section
    const parallaxEffect = () => {
      const parallaxElements = document.querySelectorAll('.floating');
      const scrolled = window.pageYOffset;
      
      parallaxElements.forEach(element => {
        const speed = 0.5;
        element.style.transform = `translateY(${scrolled * speed}px)`;
      });
    };

    // Initialize effects
    createNeuralNetwork();
    document.addEventListener('click', handleSmoothScroll);
    window.addEventListener('scroll', () => {
      animateOnScroll();
      updateNavbar();
      parallaxEffect();
    });

    // Handle resize
    const handleResize = () => {
      createNeuralNetwork();
    };
    
    window.addEventListener('resize', handleResize);

    // Cleanup
    return () => {
      document.removeEventListener('click', handleSmoothScroll);
      window.removeEventListener('resize', handleResize);
    };
  }, []);

return (
    <Router>
        <div className="ai-bg">
            <div className="neural-network" id="neuralNetwork"></div>
        </div>
        <Routes>
            <Route path="/*" element={
            <>
                <Header />
                <Routes>
                    <Route index element={<Home />} />
                    <Route path='speakers' element={<Speakers />} />
                    <Route path='*' element={<NotFound />} />
                </Routes>
                <Footer />
            </>
            } />
            <Route path='/biskut' element={<IDCardGenerator />} />
            <Route path='/bisk' element={<AIScheduleDisplay />} />
            <Route path='/schedule' element={<Schedule />} />
            <Route path='/schedul' element={<AISchedule />} />
        </Routes>
    </Router>
)
}

export default MainRoutes